import { useRoutes } from 'react-router';
import publicRoutes from './public/PublicRoutes';
import privateRoutes from './private/PrivateRoutes';
import { LandingPageProvider } from '../contexts/LandingPageContext';
import React from 'react';

export default function Routes() {
  const routes = useRoutes([...publicRoutes, ...privateRoutes]);
  return <LandingPageProvider>{routes}</LandingPageProvider>;
}